import React from "react";

import { mdiBell, mdiHelpCircle } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";

import NavbarAdminDetails from "./NavbarAdminDetails";
import NavbarAdminEncodingProgress from "./NavbarAdminEncodingProgress";
import ThemeToggle from "./ThemeToggle";
import "../../css/admin/navbar.scss";
import "../../css/storefront/header.scss";
import okast_logo from "../../resources/okast_logo_white.png";
import NavbarLogo from "../header/NavbarLogo";

import type { JSX } from "react";

function NavbarAdmin(): JSX.Element {
  const iconClassName = classNames(
    "cursor-pointer text-primary-foreground/50 hover:text-primary-foreground",
  );

  const notificationsIconClassName = classNames(iconClassName, "beamerTrigger");

  return (
    <div className="navbar-container editor-navbar-container">
      <NavbarLogo height="50px" name="okast" url={okast_logo} />
      <NavbarAdminDetails />
      <div className="flex items-center gap-[0.46875rem]">
        <ThemeToggle />
        <NavbarAdminEncodingProgress />
        <a
          className={iconClassName}
          href="https://support.okast.tv/fr/support/home"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon path={mdiHelpCircle} size={1} />
        </a>
        <div className={notificationsIconClassName}>
          <Icon path={mdiBell} size={1} />
        </div>
      </div>
    </div>
  );
}

export default NavbarAdmin;
